import React, { useState, useEffect, useCallback } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Card, Tooltip, OverlayTrigger } from 'react-bootstrap';
import RedHeartIcon from '../assets/icons/red-heart-icon.svg';
import PositiveFeedbackIcon from '../assets/icons/Union.svg';
import { getTopContent } from '../services/api.js';
import ArrowRightUp from '../assets/icons/ArrowRightUp_24px.svg';
import VerifiedIcon from '../assets/icons/verified-icon.svg';
import ErrorFallback from './ErrorFallback';

const TopContentCarousel = ({ influencerId, profileImg, platformAccountType, isVerified, creatorName }) => {
    const [topContents, setTopContents] = useState([]);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getTopContent(influencerId, platformAccountType);
                if (response.status === 200) {
                    setTopContents([]);
                    setTopContents(response.data);
                    setError(null);
                } else {
                    setTopContents([]);
                    setError("Profile not found. Please check the influencer ID.");
                }
            } catch (error) {
                setTopContents([]);
                setError("An error occurred while fetching the profile details.");
            }
        };
        fetchData();
    }, [influencerId, platformAccountType]);

    const formatFollowers = useCallback(count => {
        if (count >= 1_000_000_000) return (count / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
        if (count >= 1_000_000) return (count / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
        if (count >= 1_000) return (count / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
        return count;
    }, []);

    const formatDateString = (dateString) => {
        const options = {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        };
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', options).replace(',', '').replace(' at', ',');
    };

    const renderTooltip = (props, description) => (
        <Tooltip id="button-tooltip" {...props}>{description}</Tooltip>
    );
// 👉 Return fallback if empty or error
if (error || topContents.length === 0) {
    return (
      <ErrorFallback
        title="Top Content"
        image={require('../assets/icons/topcontent-empty.svg').default} // update to match your image path if needed
      />
    );
  }
    return (
            <Card className="border rounded-0 top-contents">
                <Card.Body>
                    <h3 className="info-header-title mb-3">Top Content</h3>
                    <div className="d-flex flex-nowrap overflow-auto gap-3 scroll-snap-x pb-2">
                        {topContents.map((item) => (
                            <div key={item.id} className="flex-shrink-0" style={{ width: '300px' }}>
                                <div className="card carousel-card card-size-bg h-100 p-0">
                                    <div className="d-flex align-items-center justify-content-between p-3">
                                        <div className="d-flex align-items-center">
                                            <img alt="avatar" width="20" height="20" className="rounded-circle" src={profileImg || "https://isomorphic-furyroad.s3.amazonaws.com/public/avatars/avatar-11.webp"} />
                                            <small className="k me-1 ms-1 creator-name">{creatorName}</small>
                                            {isVerified && <img src={VerifiedIcon} alt="Verified" width={13} height={13} className="" />}
                                        </div>
                                        <a href={item.url} target='_blank' className='cursor-pointer'><img src={ArrowRightUp} alt="Arrow" width={24} height={24}/></a>
                                    </div>
                                    <img className="" alt="content" src={item.thumbnailUrl} style={{ height: '224px', objectFit: 'cover' }} />
                                    <div className="card-body p-2">
                                        <div className="d-flex align-items-center gap-3">
                                            <div className="d-flex align-items-center">
                                                <img src={RedHeartIcon} alt="Likes" className="me-2" style={{ width: '13px', height: '13px' }} />
                                                <div className="like-comment">{formatFollowers(item.likeCount)}</div>
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <img src={PositiveFeedbackIcon} alt="Comments" className="me-2" style={{ width: '13px', height: '13px' }} />
                                                <div className="like-comment">{formatFollowers(item.commentCount)}</div>
                                            </div>
                                        </div>
                                        <OverlayTrigger
                                            placement="top"
                                            delay={{ show: 250, hide: 400 }}
                                            overlay={(props) => renderTooltip(props, item.description)}
                                        >
                                            <p className="info-name-container content-description">
                                            <small className="k me-1 creator-name">{creatorName}</small>
                                            {isVerified && <img src={VerifiedIcon} alt="Verified" width={13} height={13} className="me-2" />}
                                                {item.description.length > 80 ? `${item.description.slice(0, 80)}...` : item.description}
                                            </p>
                                        </OverlayTrigger>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Card.Body>
            </Card>
    );
};

export default TopContentCarousel;
